import React, { useState, useEffect, useCallback } from "react";
import { Container, Form } from "react-bootstrap";
import Select from "react-select";
import ElementLoader from "../Loader/ElementLoader";
import { Link, Redirect } from "react-router-dom";
import Switch from "react-switch";
import Modal from "react-bootstrap/Modal";
import GatewayUrl from "../Gateway/Gateway";
import { RootState } from '../../store/store'
import { useSelector } from 'react-redux'
import { IReasons, ITimes } from '../../interface/absences'
import { useDispatch } from 'react-redux'
import { handleLoadingError } from '../../store/features/session'
import { setAbsenceChangeCompledetModal } from '../../store/features/absences'
import SelectCustomStyles from "../SelectCustomStyles/SelectCustomStyles";
import { IAbsenceEntry } from '../../interface/absenceEntry'

const ReasonIsSick = ["bf05f280-3ba4-4246-921d-2a9914a38fbb", "e5523cc3-3099-4bea-a5ab-952b20a0fe02"];
const ReasonIsCompensationOfExtraHoursId: string = "c317c1d9-e2b0-460e-a4d2-a33f95750d0f";
const ReasonToBlockDateRange: any = ["c317c1d9-e2b0-460e-a4d2-a33f95750d0f", "b58c03d7-6dc9-45e2-8cd9-b0dd64edc8de"];

const ResponseModal = (props: any): JSX.Element => {
  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body>
        <div className="text-center">
          <h4>{props.ModalContent}</h4>

          <div className="btn btn-secondary mt-4" onClick={props.onHide}>
            ok.
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const EditLearnTime = () => {
  const dispatch = useDispatch()

  const AbsenceReasons: Array<IReasons> = useSelector((state: RootState) => state.absenceReasons.reasons)
  const AbsenceTimes: Array<ITimes> = useSelector((state: RootState) => state.absenceReasons.times)
  const editAbsenceTime: IAbsenceEntry = useSelector((state: RootState) => state.absenceReasons.editEntry)

  const [IsLoading, setIsLoading] = useState(true);
  const [DocumentName, setDocumentName] = useState("");
  const [DocumentTrigger, setDocumentTrigger] = useState(false);
  const [DocumentUpload, setDocumentUpload]: any = useState(null);
  const [WrongUploadFormat, setWrongUploadFormat] = useState(false);
  const [FormIsLoading, setFormIsLoading] = useState(false);
  const [AbsentReason, setAbsentReason] = useState({ label: "Grund der Abwesenheit", value: "" });
  const [AbsentReasonText, setAbsentReasonText] = useState(editAbsenceTime ? editAbsenceTime.reasonComment : "");
  const [SelectedFromDay, setSelectedFromDay] = useState(editAbsenceTime ? editAbsenceTime.fromDate : "");
  const [SelectedTillDay, setSelectedTillDay] = useState(editAbsenceTime ? editAbsenceTime.tillDate : "");
  const [ForceWholeDay, setForceWholeDay] = useState(false);
  const [ModalContent, setModalContent] = useState("");
  const [ReasonIsCompensationOfExtraHours, setReasonIsCompensationOfExtraHours] = useState(false);
  const [BlockDateRange, setBlockDateRange] = useState(false);
  const [doRedirect, setDoRedirect] = useState(false);
  const [ReasonIsSickness, setReasonIsSickness] = useState(false);
  const [modalShow, setModalShow] = useState(false);

  let uploadFileId: number = editAbsenceTime ? parseInt(editAbsenceTime.uploadFile_id) : 0;

  const [SelectedBeginn, setSelectedBeginn] = useState(
    editAbsenceTime
      ? editAbsenceTime.fromTime === "00:00"
        ? { value: "", label: "Anfang" }
        : { value: editAbsenceTime.fromTime, label: editAbsenceTime.fromTime }
      : { value: "", label: "Anfang" }
  );

  const [SelectedEnd, setSelectedEnd] = useState(
    editAbsenceTime
      ? editAbsenceTime.tillTime === "00:00"
        ? { value: "", label: "Ende" }
        : { value: editAbsenceTime.tillTime, label: editAbsenceTime.tillTime }
      : { value: "", label: "Ende" }
  );

  const [selectDateFromAndToAreSameDay, setSelectDateFromAndToAreSameDay] = useState(
    editAbsenceTime ? (editAbsenceTime.fromDate === editAbsenceTime.tillDate ? true : false) : false
  );

  const identifyAbsenceReason = useCallback(() => {
    if (editAbsenceTime) {
      for (let index = 0; index < AbsenceReasons.length; index++) {
        if (AbsenceReasons[index].label === editAbsenceTime.reason) {
          setAbsentReason(AbsenceReasons[index]);
          setReasonIsCompensationOfExtraHours(AbsenceReasons[index]["value"] === ReasonIsCompensationOfExtraHoursId ? true : false);
          setReasonIsSickness(ReasonIsSick.includes(AbsenceReasons[index]["value"]) ? true : false);

          setForceWholeDay(
            ReasonIsSick.includes(AbsenceReasons[index]["value"]) || (editAbsenceTime.fromTime === "00:00" && editAbsenceTime.fromTime === "00:00")
              ? true
              : false
          );

          setBlockDateRange(ReasonToBlockDateRange.includes(AbsenceReasons[index]["value"]) ? true : false);

          setIsLoading(false);
          break;
        }
      }
    }
  }, [AbsenceReasons, editAbsenceTime]);

  useEffect(() => {
    window.scrollTo(0, 0);

    identifyAbsenceReason();
  }, [dispatch, editAbsenceTime, AbsenceReasons, identifyAbsenceReason]);

  const ChangeDateBeginn = (event: any) => {
    setSelectedBeginn({ value: event.value, label: event.value });
  };

  const ChangeDateEnd = (event: any) => {
    setSelectedEnd({ value: event.value, label: event.value });
  };

  const absentReasonChanged = (e: any) => {
    setBlockDateRange(ReasonToBlockDateRange.includes(e.value) ? true : false);
    setAbsentReasonText("");

    if (ReasonIsSick.includes(e.value)) {
      setSelectedBeginn({ value: "", label: "Anfang" });
      setSelectedEnd({ value: "", label: "Ende" });
      setReasonIsSickness(true);
      setForceWholeDay(true);
    } else {
      if (ReasonToBlockDateRange.includes(e.value)) {
        setSelectedTillDay(SelectedFromDay);
        setReasonIsCompensationOfExtraHours(false);
      }

      if (e.value === ReasonIsCompensationOfExtraHoursId) {
        setReasonIsCompensationOfExtraHours(true);
        setDocumentName("");
        setDocumentTrigger(false);
        setDocumentUpload(null);
      } else {
        setReasonIsCompensationOfExtraHours(false);
      }

      setReasonIsSickness(false);
      setForceWholeDay(false);
    }

    setAbsentReason(e);
    setAbsentReasonText("");
  };

  const selectFileForUpload = (event: any) => {
    setDocumentName(event.target.files[0] ? event.target.files[0].name : "");
    setDocumentTrigger(event.target.files[0] ? true : false);
    setDocumentUpload(event.target.files[0] ? event.target.files[0] : null);
  };

  const textareaOnChange = (e: any) => {
    if (e.target.value.length <= 30) {
      setAbsentReasonText(e.target.value);
    }
  };

  const removeFileFromUpload = () => {
    setDocumentName("");
    setDocumentTrigger(false);
    setDocumentUpload(null);
  };

  const submitForm = () => {
    setFormIsLoading(true);
    uploadAbsenceFile();
  };

  const uploadAbsenceFile = () => {
    if (DocumentUpload !== null) {
      let data = new FormData();
      data.append("file", DocumentUpload);
      data.append("method", "uploadFiles");

      fetch(GatewayUrl, {
        method: "POST",
        body: data,
      })
        .then((response) => response.json())
        .then((result) => {
          result = JSON.parse(result);
          if (Object.keys(result).length === 0) {
            dispatch(handleLoadingError("lzk#990044"));
          } else if (result.error) {
            setWrongUploadFormat(true);
            setFormIsLoading(false);
          } else {
            uploadFileId = result.createdAbsenceId;
            removeFileFromUpload();
            createAbsenceTime();
          }
        })
        .catch(() => dispatch(handleLoadingError("lzk#990022")));
    } else {
      createAbsenceTime();
    }
  };

  const createAbsenceTime = () => {
    fetch(GatewayUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        method: "editExistingAbsenceTime",
        fromDate: SelectedFromDay,
        tillDate: SelectedTillDay,
        absenceID: editAbsenceTime.id,
        SelectTimeBegin: selectDateFromAndToAreSameDay ? String(SelectedBeginn.value) : "",
        SelectTimeEnd: selectDateFromAndToAreSameDay ? String(SelectedEnd.value) : "",
        SelectAbsentReasonId: AbsentReason.value,
        reasonComment: AbsentReasonText,
        createdAbsenceId: uploadFileId,
      }),
    })
      .then((response) => response.json())
      .then((result) => {
        setFormIsLoading(false);

        if (Object.keys(result).length === 0) {
          dispatch(handleLoadingError("lzk#990045"));
          setFormIsLoading(false);
        } else if (result.error) {
          setModalContent(result.message);
          setModalShow(true);
          setFormIsLoading(false);
        } else if (result.status === "success") {
          setDoRedirect(true);
          dispatch(setAbsenceChangeCompledetModal(true));
        }
      })
      .catch(() => dispatch(handleLoadingError("lzk#990023")));

    uploadFileId = 0;
  };

  const changeSelectDateFrom = (event: any) => {
    const isSameDay: boolean = event.target.value === SelectedTillDay || ReasonToBlockDateRange.includes(AbsentReason.value) ? true : false;

    setSelectedFromDay(event.target.value);
    setSelectDateFromAndToAreSameDay(isSameDay);

    if (!ReasonToBlockDateRange.includes(AbsentReason.value)) {
      if (!isSameDay) {
        setSelectedBeginn({ value: "", label: "Anfang" });
        setSelectedEnd({ value: "", label: "Ende" });
      }
    } else {
      changeSelectDateTo(event);
    }
  };

  const changeSelectDateTo = (event: any) => {
    const isSameDay: boolean = SelectedFromDay === event.target.value || ReasonToBlockDateRange.includes(AbsentReason.value) ? true : false;

    setSelectedTillDay(event.target.value);
    setSelectDateFromAndToAreSameDay(isSameDay);

    if (!ReasonToBlockDateRange.includes(AbsentReason.value)) {
      if (!isSameDay) {
        setSelectedBeginn({ value: "", label: "Anfang" });
        setSelectedEnd({ value: "", label: "Ende" });
      }
    }
  };

  const handleCheckSelectDateFrom = () => {
    return SelectedFromDay.length === 0 ? true : false;
  };

  const handleCheckSelectDateTo = () => {
    return SelectedTillDay.length === 0 ? true : false;
  };

  const handleCheckSelectTimeBegin = () => {
    return !selectDateFromAndToAreSameDay || ForceWholeDay
      ? false
      : ReasonIsSickness
        ? false
        : SelectedBeginn.value === null || SelectedBeginn.value === "00:00" || SelectedBeginn.value === ""
          ? true
          : false;
  };

  const handleCheckSelectTimeEnd = () => {
    return !selectDateFromAndToAreSameDay || ForceWholeDay
      ? false
      : ReasonIsSickness
        ? false
        : SelectedEnd.value === null || SelectedEnd.value === "00:00" || SelectedEnd.value === ""
          ? true
          : false;
  };

  const handleCheckIfSelectTimeBeginIsLowerThenSelectTimeEnd = () => {
    var FromTimeMilliSeconds: any = SelectedBeginn.value.split(":");
    FromTimeMilliSeconds = FromTimeMilliSeconds[0] * 3600 * 1000 + FromTimeMilliSeconds[1] * 60 * 1000;

    var TillTimeMilliSeconds: any = SelectedEnd.value.split(":");
    TillTimeMilliSeconds = TillTimeMilliSeconds[0] * 3600 * 1000 + TillTimeMilliSeconds[1] * 60 * 1000;

    return selectDateFromAndToAreSameDay &&
      SelectedBeginn.value &&
      SelectedBeginn.value.length > 0 &&
      SelectedEnd.value &&
      SelectedEnd.value.length > 0 &&
      FromTimeMilliSeconds >= TillTimeMilliSeconds
      ? true
      : false;
  };

  const handleCheckIfSelectDateBeginIsLowerThenSelectDateEnd = () => {
    return SelectedFromDay.length > 0 && SelectedTillDay.length > 0 && SelectedFromDay > SelectedTillDay ? true : false;
  };

  const handleCheckSelectCategory = () => {
    return !AbsentReason ? true : false;
  };

  const handleIsReasonOtherAndHasValue = () => {
    return (AbsentReason.value === "938b782c-8c9b-4795-8d6b-298c317427f4" || AbsentReason.value === "b58c03d7-6dc9-45e2-8cd9-b0dd64edc8de") &&
      AbsentReasonText.length === 0
      ? true
      : false;
  };

  const handleCheckFormFilds = () => {
    return !handleCheckSelectDateFrom() &&
      !handleCheckSelectDateTo() &&
      !handleCheckSelectTimeBegin() &&
      !handleCheckSelectTimeEnd() &&
      !handleCheckIfSelectTimeBeginIsLowerThenSelectTimeEnd() &&
      !handleCheckSelectCategory() &&
      !handleCheckIfSelectDateBeginIsLowerThenSelectDateEnd() &&
      !handleIsReasonOtherAndHasValue()
      ? true
      : false;
  };

  const ValidatingFormular = () => {
    return handleCheckFormFilds();
  };

  const handleChangeWholeDaySwitch = () => {
    setForceWholeDay(ForceWholeDay ? false : true);
    setSelectedBeginn({ value: "", label: "Anfang" });
    setSelectedEnd({ value: "", label: "Ende" });
  };

  const HandleSetModalShow = (bool: boolean) => {
    setModalShow(bool);
    setFormIsLoading(false);
  };

  if (doRedirect === true || editAbsenceTime.id === "") {
    return <Redirect to="/" />;
  } else if (IsLoading) {
    return <ElementLoader></ElementLoader>;
  } else {
    const formIsValid = ValidatingFormular();
    return (
      <div className="container-wbs fixing-select-index-issue">
        <form>
          <Container>
            {WrongUploadFormat ? (
              <div className="alert alert-danger alert-danger-wbs" role="alert">
                <h4 className="alert-heading">Falsches Format!</h4>
                <p>Bitte beachten Sie das nur Bild- und PDF Dateien zugelassen sind.</p>
                <hr />
                <small>
                  Erlaubte Formate für den Upload sind: jpeg, jp2, jpc, j2c, j2k, jpx, jpg, png, pdf
                </small>
              </div>
            ) : null}

            <div className="row">
              <div className="col-md-12 mt-4">
                <label>Grund der Abwesenheit</label>
                <p><b>Achtung NEU! - bei Krankmeldungen wird zwischen AU (Papierform) und eAU (Elektronische Krankmeldung) unterschieden</b></p>
                <Select
                  isSearchable={false}
                  placeholder="Grund der Abwesenheit"
                  closeMenuOnSelect={true}
                  options={AbsenceReasons}
                  onChange={absentReasonChanged}
                  value={AbsentReason}
                  styles={SelectCustomStyles}
                />
              </div>

              {AbsentReason &&
                (AbsentReason.value === "938b782c-8c9b-4795-8d6b-298c317427f4" || AbsentReason.value === "b58c03d7-6dc9-45e2-8cd9-b0dd64edc8de") ? (
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-8 mt-4">
                      <label>Bitte beschreiben Sie den Grund der Abwesenheit.</label>
                    </div>
                    <div className="col-4 mt-4">
                      <label className="text-right w-100">{AbsentReasonText.length} / 30 Zeichen</label>
                    </div>

                    <div className="col-12">
                      <textarea
                        placeholder="Bitte beschreiben Sie den Grund der Abwesenheit."
                        className="form-control lzk-capture-time-textarea"
                        rows={3}
                        value={AbsentReasonText}
                        onChange={textareaOnChange}
                        maxLength={30}
                      ></textarea>
                    </div>
                  </div>
                </div>
              ) : null}

              <div className="col-lg col-md-2 mt-4" style={{ maxWidth: "100px" }}>
                <label>Ganztägig</label>
                <p className="my-auto">
                  <Switch
                    onChange={handleChangeWholeDaySwitch}
                    checked={ForceWholeDay}
                    onColor="#fa7268"
                    offColor="#01254b"
                    handleDiameter={30}
                    height={37}
                    width={80}
                    className="react-switch"
                    disabled={ReasonIsSickness || !selectDateFromAndToAreSameDay || ReasonIsCompensationOfExtraHours}
                  />
                </p>
              </div>

              <div className="col-lg col-md mt-4">
                <label>Von</label>
                <input type="date" className="form-control" onChange={(event) => changeSelectDateFrom(event)} value={SelectedFromDay} />
              </div>

              <div className="col-lg col-md-5 mt-4">
                <label>Bis</label>
                <input
                  type="date"
                  className="form-control"
                  onChange={(event) => changeSelectDateTo(event)}
                  value={SelectedTillDay}
                  disabled={(ReasonIsCompensationOfExtraHours && AbsentReason.value !== "") || BlockDateRange}
                />
              </div>

              <div className="col-lg col-md-6 mt-4">
                <label>Anfang</label>
                <Select
                  isSearchable={false}
                  isDisabled={!selectDateFromAndToAreSameDay || ReasonIsSickness || ForceWholeDay}
                  placeholder="Beginn"
                  options={AbsenceTimes}
                  onChange={ChangeDateBeginn}
                  value={SelectedBeginn}
                  styles={SelectCustomStyles}
                />
              </div>

              <div className="col-lg col-md-6 mt-4">
                <label>Ende</label>
                <Select
                  isSearchable={false}
                  isDisabled={!selectDateFromAndToAreSameDay || ReasonIsSickness || ForceWholeDay}
                  placeholder="Ende"
                  options={AbsenceTimes}
                  onChange={ChangeDateEnd}
                  value={SelectedEnd}
                  styles={SelectCustomStyles}
                />
              </div>
            </div>

            <div className="row"></div>

            <div className="row">
              <div className="col-md-12 mt-4">
                <p>
                  <b>
                    Bitte beachten Sie. Laden Sie nur die Arbeitgeberversion der Arbeitsunfähigkeitsbescheinigung hoch. Falls Sie nur eine Arbeitsunfähigkeitsbescheinigung mit Diagnose haben, machen Sie diese bitte Unkenntlich, bevor Sie diese hochladen.
                  </b>
                </p>
              </div>

              <div className="col-md-6 mt-1">
                <label>Abwesenheitsnachweis</label>
                <Form.File
                  onChange={(event: any) => selectFileForUpload(event)}
                  className="custom-upload"
                  id="custom-file"
                  label="zum auswählen hier klicken"
                  custom
                  data-browse="Hochladen"
                  accept="image/*, .pdf"
                  disabled={ReasonIsCompensationOfExtraHours}
                />
                <small>Erlaubte Formate für den Upload sind: jpeg, jp2, jpc, j2c, j2k, jpx, jpg, png, pdf</small>
                <br></br>
                <small>Maximale Dateigröße: 4MB</small>
              </div>

              {DocumentTrigger ? (
                <div className="col-md-6 mt-4">
                  <label>Ihr ausgewähltes Dokument:</label>

                  <div className="form-row">
                    <div className="col-10">
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Readonly input here..."
                        value={DocumentName}
                        aria-label="readonly input example"
                        readOnly
                      />
                    </div>
                    <div className="col-2">
                      <div className="btn btn-secondary btn-block" onClick={removeFileFromUpload}>
                        <i className="fal fa-trash-alt"></i>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>

            <div className="row"></div>

            <div className="row">
              <div className="col-md-12 mt-4">
                {AbsentReason ? (
                  <div>
                    {editAbsenceTime.realName === "" ? null : (
                      <div>
                        <label>Ihr bereits hochgeladenes Dokument:</label>

                        <input
                          className="form-control"
                          type="text"
                          placeholder="Readonly input here..."
                          value={editAbsenceTime.realName}
                          aria-label="readonly input example"
                          readOnly
                        />
                      </div>
                    )}
                  </div>
                ) : null}
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12 mt-4 text-right">
                <Link to="/aktuelle-abwesenheiten">
                  <div className="btn btn-secondary py-3 px-5 m-1">zurück</div>
                </Link>

                {formIsValid ? (
                  FormIsLoading ? (
                    <button className="btn btn-primary py-3 px-5 m-1" type="button" disabled>
                      <span className="spinner-border spinner-border-sm mr-3" role="status" aria-hidden="true"></span>
                      bitte warten...
                    </button>
                  ) : (
                    <div className="btn btn-primary py-3 px-5 m-1" onClick={submitForm}>
                      Abwesenheit ändern.
                    </div>
                  )
                ) : (
                  <div className="btn btn-primary py-3 px-5 m-1 disabled">Abwesenheit ändern.</div>
                )}
              </div>
            </div>
          </Container>
        </form>

        <ResponseModal show={modalShow} ModalContent={ModalContent} onHide={() => HandleSetModalShow(false)} />
      </div>
    );
  }
};

export default EditLearnTime;
